import React from "react";
import { FaArrowRight } from "react-icons/fa";
import "./ErodeBookFair.css";

// Replace with the actual promo/gist video for the book fair.
const BOOKFAIR_VIDEO = "https://media.mpdatahub.com/uploads/ERODE%20READS%202026.mp4";
const BOOKFAIR_POSTER = "/images/bfposter.png";

// Replace with the book fair's own website.
const BOOKFAIR_SITE_URL = "https://www.erodebookfestival.in/";

const ErodeBookFair = () => {
  return (
    <div className="bookfair-page">
      <video
        className="bookfair-video"
        src="https://media.mpdatahub.com/uploads/ERODE%20READS%202026.mp4"
        poster={BOOKFAIR_POSTER}
        autoPlay
        muted
        loop
        playsInline
      />
      <div className="bookfair-scrim" />

      <div className="bookfair-content">
        <span className="bookfair-eyebrow">2005 முதல் &mdash; ஆண்டுதோறும்</span>
        <h1 className="bookfair-title">ஈரோடு புத்தகத் திருவிழா</h1>
        <p className="bookfair-desc">
          2005 ஆம் ஆண்டு முதல் மக்கள் சிந்தனைப் பேரவையால் நடத்தப்படும் ஈரோடு
          புத்தகத் திருவிழா ஒவ்வொரு ஆண்டும் மிகச் சிறப்பாக நடைபெற்று
          வருகிறது.
        </p>
        <a
          className="bookfair-cta"
          href={BOOKFAIR_SITE_URL}
          target="_blank"
          rel="noopener noreferrer"
        >
          திருவிழா இணையதளத்திற்குச் செல்ல <FaArrowRight />
        </a>
      </div>
    </div>
  );
};

export default ErodeBookFair;